<template>
    <v-dialog width="800px" v-model="show">
        <v-card>
            <v-toolbar color="red" dark>
                <v-toolbar-title>{{$t('lang.task.start')}}</v-toolbar-title>
            </v-toolbar>
            <v-data-table :items="items" :headers="fields"
                          :total-items="totalRows"
                          :rows-per-page-items="rowsPerPageItems"
                          @update:pagination="onPaging">
                <template slot="headers">
                    <th v-for="header in fields" :width="header.width" style="text-align:left">
                        <v-checkbox v-if="header.value=='checkbox'" color="primary" hide-details ></v-checkbox>
                        <div v-else>
                            {{$t(header.text)}}
                        </div>
                    </th>
                </template>
                <template slot="items" slot-scope="data">
                    <td>
                        {{pageSize*(currentPage-1)+data.index+1}}
                    </td>
                    <td><a @click="onSelect(data.item)">{{data.item['flowCode']}}</a></td>
                    <td>{{data.item['flowName']}}</td>
                </template>
            </v-data-table>
        </v-card>
    </v-dialog>
</template>

<script>
    import axios from "axios/index";
    import VueController from "../../../../public/js/controller";

    export default {
        name: 'flow-select',
        components: {},
        inheritAttrs: true,
        props: {
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            }
        },
        created() {
            VueController.push(this);
            this.search();
        },
        destroyed(){
          VueController.removeComponentByEl(this);
        },
        data: () => {
            return {
                fields: [
                    {value: "index", text: "lang.common.index", width: "10%", sortable: false},
                    {value: 'flowName', text: 'lang.workflow.name', width: "45%", sortable: false},
                    {value: 'flowCode', text: 'lang.workflow.code', width: "45%", sortable: false}
                ],
                show:false,
                initData: {},
                items: [],
                pagination: {},
                pageSize: 10,
                currentPage: 1,
                totalRows: 0
            }
        },
        methods: {
            search: function () {
                ////console.log("vu manh ha");
                axios.post(process.env.VUE_APP_API_URL + "/workflow/search?pageSize=" + this.pageSize + "&page=" + this.currentPage, {}).then(data => {
                    this.items = data.items;
                    this.totalRows = data.count;
                }, error => {
                    alert(error);
                });
            },

            onShow:function(sh, variable){
                this.show = sh;
                this.initData = variable;
            },

            onSelect: function (data) {
                this.show = false;
                //let formSubmit = VueController.getComponentByComponentName("form-submit");
                let formSubmit = VueController.getComponentByComponentName("form-input");
                formSubmit.onShowForm(data.processDefinitionId,this.initData);
            },


            onPaging: function (page) {
                this.pagination = page.page;
                this.currentPage = page.page;
                this.pageSize = page.rowsPerPage;
                this.search();
            }
        }


    }
</script>
